(function () {
  function waitSwiper(cb, tries) {
    tries = tries || 0;
    if (typeof Swiper !== 'undefined') {
      cb();
      return;
    }
    if (tries > 120) return;
    requestAnimationFrame(function () {
      waitSwiper(cb, tries + 1);
    });
  }

  function teardown(root) {
    if (!root) return;
    var swEl = root.querySelector('.js-specialists-team-swiper');
    if (swEl && swEl.swiper) {
      swEl.swiper.destroy(true, true);
    }
    delete root.dataset.carouselMounted;
  }

  function mount(root) {
    if (!root || root.dataset.carouselMounted === 'true') return;
    var swEl = root.querySelector('.js-specialists-team-swiper');
    if (!swEl) return;

    waitSwiper(function () {
      if (!root.isConnected || root.dataset.carouselMounted === 'true') return;

      var autoplay =
        root.dataset.autoplay === 'true'
          ? {
              delay: parseInt(root.dataset.autoplayDelay || '5000', 10),
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false;

      var swiper = new Swiper(swEl, {
        slidesPerView: 1,
        spaceBetween: parseInt(root.dataset.spaceBetween || '16', 10),
        speed: parseInt(root.dataset.speed || '500', 10),
        watchOverflow: true,
        autoplay: autoplay,
        loop:
          root.dataset.loop === 'true' &&
          swEl.querySelectorAll('.swiper-slide').length > 1,
        pagination: {
          el: root.querySelector('.js-specialists-team-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: root.querySelector('.js-specialists-team-next'),
          prevEl: root.querySelector('.js-specialists-team-prev'),
        },
        a11y: {
          enabled: true,
          paginationBulletMessage: 'Go to slide {{ index }}',
        },
      });

      root.dataset.carouselMounted = 'true';
      root._specialistsTeamSwiper = swiper;
    });
  }

  function mountAll() {
    document.querySelectorAll('[data-specialists-carousel]').forEach(function (root) {
      mount(root);
    });
  }

  function domReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  domReady(mountAll);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-specialists-carousel]');
    if (root) mount(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-specialists-carousel]');
    if (root) teardown(root);
  });
})();
